'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002etemporal$002e$002dChrono$002dUnit from "./java.time.temporal.-Chrono-Unit.js";
var $p;
/** @constructor */
function $c_Ljava_time_Period$() {
  this.Jc = null;
  this.Jd = false;
}
export { $c_Ljava_time_Period$ as $c_Ljava_time_Period$ };
$p = $c_Ljava_time_Period$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_Period$;
/** @constructor */
function $h_Ljava_time_Period$() {
}
export { $h_Ljava_time_Period$ as $h_Ljava_time_Period$ };
$h_Ljava_time_Period$.prototype = $p;
$p.tP = (function() {
  if ((!this.Jd)) {
    this.Jc = new $c_Ljava_time_Period(0, 0, 0);
    this.Jd = true;
  }
  return this.Jc;
});
$p.xy = (function(years, months, days) {
  return ((((years | months) | days) === 0) ? this.tP() : new $c_Ljava_time_Period(years, months, days));
});
var $d_Ljava_time_Period$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Period$, "java.time.Period$", ({
  l8: 1
}));
export { $d_Ljava_time_Period$ as $d_Ljava_time_Period$ };
var $n_Ljava_time_Period$;
function $m_Ljava_time_Period$() {
  if ((!$n_Ljava_time_Period$)) {
    $n_Ljava_time_Period$ = new $c_Ljava_time_Period$();
  }
  return $n_Ljava_time_Period$;
}
export { $m_Ljava_time_Period$ as $m_Ljava_time_Period$ };
/** @constructor */
function $c_Ljava_time_Period(years, months, days) {
  this.hF = 0;
  this.gS = 0;
  this.iK = 0;
  this.hF = years;
  this.gS = months;
  this.iK = days;
}
export { $c_Ljava_time_Period as $c_Ljava_time_Period };
$p = $c_Ljava_time_Period.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_Period;
/** @constructor */
function $h_Ljava_time_Period() {
}
export { $h_Ljava_time_Period as $h_Ljava_time_Period };
$h_Ljava_time_Period.prototype = $p;
$p.VB = (function() {
  return (this === $m_Ljava_time_Period$().tP());
});
$p.Yc = (function() {
  var value = this.hF;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = this.gS;
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
  return $j_java$002elang$002e$002dObject.$bL(lo$1, hi$3);
});
$p.Sa = (function(temporal) {
  var _temporal = temporal;
  if ((this.hF !== 0)) {
    if ((this.gS !== 0)) {
      var $x_2 = _temporal;
      var $x_1 = this.Yc();
      _temporal = $x_2.is($x_1.l, $x_1.h, $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit());
    } else {
      var $x_3 = _temporal;
      var value = this.hF;
      var hi = (value >> 31);
      _temporal = $x_3.is(value, hi, $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit());
    }
  } else if ((this.gS !== 0)) {
    var $x_4 = _temporal;
    var value$1 = this.gS;
    var hi$1 = (value$1 >> 31);
    _temporal = $x_4.is(value$1, hi$1, $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit());
  }
  if ((this.iK !== 0)) {
    var $x_5 = _temporal;
    var value$2 = this.iK;
    var hi$2 = (value$2 >> 31);
    _temporal = $x_5.is(value$2, hi$2, $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit());
  }
  return _temporal;
});
$p.f = (function(obj) {
  return ((obj instanceof $c_Ljava_time_Period) && ((this === obj) || (((this.hF === obj.hF) && (this.gS === obj.gS)) && (this.iK === obj.iK))));
});
$p.m = (function() {
  var $x_1 = this.hF;
  var i = this.gS;
  var i$1 = this.iK;
  return (((($x_1 + ((i << 8) | ((i >>> 24) | 0))) | 0) + ((i$1 << 16) | ((i$1 >>> 16) | 0))) | 0);
});
$p.b = (function() {
  if ((this === $m_Ljava_time_Period$().tP())) {
    return "P0D";
  } else {
    var buf = $j_java$002elang$002e$002dObject.$ct_scm_StringBuilder__(new $j_java$002elang$002e$002dObject.$c_scm_StringBuilder());
    buf.ia(80);
    if ((this.hF !== 0)) {
      buf.d9(this.hF).ia(89);
    }
    if ((this.gS !== 0)) {
      buf.d9(this.gS).ia(77);
    }
    if ((this.iK !== 0)) {
      buf.d9(this.iK).ia(68);
    }
    return buf.ax.r;
  }
});
function $isArrayOf_Ljava_time_Period(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dB)));
}
export { $isArrayOf_Ljava_time_Period as $isArrayOf_Ljava_time_Period };
var $d_Ljava_time_Period = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Period, "java.time.Period", ({
  dB: 1,
  dK: 1,
  ld: 1,
  a: 1
}));
export { $d_Ljava_time_Period as $d_Ljava_time_Period };
